module.exports = __webpack_public_path__ + "img/project-innerpage-1.jpg?636adb1ccc1ad595a86dd9c6711805d8";